import { css } from '@emotion/core';
import Color from 'color';
import { makeStyles } from '@material-ui/core/styles';
import { lightenDarkenColor, adjustColorAlpha } from 'utils/colorConvert';
import { feverShake } from 'styles/keyframes';

export const btnVariants = {
    FILLED: 'filled',
    OUTLINED: 'outlined',
    TEXT: 'text'
};

export function getColorRGBA(color) {
    try {
        return Color(color).rgb().object();
    } catch (error) {
        console.log(error);
        return {};
    }
}

export const getShakeAnimationStyle = () => css`
    animation: ${feverShake} 0.5s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
    animation-delay: 0s;
    transition-delay: 0s;
`;

export const absolutePositionCenterStyle = `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
`;

export const preventMarginCollapse = `
    &:before {
        display: table;
        content: ' ';
    }
    &:after {
        display: table;
        content: ' ';
    }
`;

export const containerShadow = `box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);`;

export const shadowLightStyle = `
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14);
`;

// 使用演算法自動判斷按鈕背景顏色後決定顯示「白色」or「黑色」文字
export function getForegroundColor(color) {
    if (!color) {
        return '';
    }
    const { r = 0, g = 0, b = 0 } = getColorRGBA(color);
    const sum = Math.round((parseInt(r) * 299 + parseInt(g) * 587 + parseInt(b) * 114) / 1000);
    return sum > 128 ? 'black' : 'white';
}

export const addHoverStyle = (styleObj = {}) => ({
    ...styleObj,
    ...(styleObj.backgroundColor
        ? {
              '&:hover': {
                  backgroundColor: lightenDarkenColor(styleObj.backgroundColor, 0.1)
              }
          }
        : {})
});

export const addOutlineBtnHoverStyle = color =>
    color
        ? {
              borderColor: color,
              '& *': {
                  color
              },
              '&:hover': {
                  borderColor: color,
                  backgroundColor: adjustColorAlpha(color, 0.04)
              }
          }
        : {};

export const lineClampStyle = rowsMax => css`
    display: block; /* Fallback for non-webkit */
    display: -webkit-box;
    -webkit-line-clamp: ${rowsMax};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: pre-wrap;
`;

export const themedButtonStyle = (color, btnVariant = btnVariants.FILLED) => css`
    color: ${btnVariant === 'text' ? color : getForegroundColor(color)};
    background-color: ${btnVariant === 'text' ? 'transparent' : color};

    &:hover {
        background-color: ${btnVariant === 'text' ? 'transparent' : color};
    }
`;

export const usePopupStyle = makeStyles({
    startButton: props => ({
        color: props.popupButtonBgColor,
        '& *': {
            color: props.popupButtonBgColor
        }
    }),
    endButton: props =>
        addHoverStyle({
            backgroundColor: props.popupButtonBgColor,
            color: props.popupButtonTextColor,
            '& *': {
                color: props.popupButtonTextColor
            }
        }),
    popup: props => ({
        backgroundColor: props.popupBgColor,
        '& .MuiDialogTitle-root .MuiTypography-root': {
            color: props.popupTextColor
        },
        margin: '16px'
    }),
    closeIcon: props => ({
        color: props.popupTextColor,
        '& svg': {
            color: `${props.popupTextColor} !important`
        }
    })
});
